import React from "react";
// import { icons } from "react-icons";
import { BsArrowRightSquareFill } from "react-icons/bs";
import { Link } from "react-scroll";
export default function Home() {
  return (
    <div
      name="Home"
      className="h-screen w-full bg-gradient-to-b from-black via-gray-600 bg-gray-500 text-white"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4  md:flex-row">
        <div className="flex flex-col justify-center h-full">
          <h2 className="text-4xl pt-16 sm:text-5xl font-bold text-white">
            I am Mritunjay Sharan
          </h2>
          <p className="text-gray-200 py-4 max-w-2xl text-xl">
            Hello Everyone ! As an aspiring web developer and coding enthusiast,
            I am specialize in coding and programming, and my work involves
            using a variety of programming languages, frameworks, and tools. In
            terms of my technical skills, I am proficient in HTML, CSS,
            JavaScript, and various web development frameworks such as React. I
            am also learning backend technologies like Node.js and PHP, as well
            as databases such as MySQL and MongoDB. Apart from technical skills,
            I am also a strong communicator, problem-solver, and a quick
            learner. I am passionate about staying up-to-date with the latest
            web development trends and technologies to continuously improve my
            skills and deliver high-quality work with my project. Overall, I am
            excited to use my skills and expertise to create dynamic and
            engaging websites and web applications that meet the needs of my
            clients and users.
          </p>

          <div>
            <Link
              to="Project"
              smooth
              duration={600}
              className="group text-white w-fit items-center rounded-md  bg-gradient-to-b from-cyan-400 to-cyan-400 cursor-pointer bord border-solid  flex flex-row p-3 "

              // bg-teal-50
              //  bg-gradient-to-b from-cyan-400 to-blue-300
            >
              Project
              <span className="ml-2 group-hover:rotate-90 duration-300 ">
                <BsArrowRightSquareFill size={20} />
              </span>
            </Link>
          </div>
        </div>
        {/* <div>
            <img src="" alt="My "/>
          </div> */}
      </div>
    </div>
  );
}
